import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'removehtmltag'
})
export class RemovehtmltagPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string) {
    if (value) {
      var result = value.replace(/<\/?[^>]+(>|$)/g, ''); //  removing html tag using regex pattern
      return result;
    }
    else {
    }
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-doctoradvice/RemovehtmltagPipe.pipe.ts